import EventEmitter from 'events';
import SDIConstants from '../SDIConstants';
import { Dispatcher } from 'simplr-flux';
import * as $ from 'jquery';

class BinToBinStore extends EventEmitter {
    SearchItemData = "";
    TransferResData = "";
    updateFavPageResponse = { updateType: 0, responseStr: "" };
     /***
     * BTB_PC_06 - Deepthi N H
     * */
    handleBinToBinStore = (action) => {
       // 
        // $(`#${SDIConstants.SDILoader}`).addClass('hide');
        switch (action.action.type) {
            case "SearchItem": {
                this.SearchItemData = action.action.response;
                ;
                this.emit('SearchItem');
                break;
            }
            case "TruckPageLoad": {
                this.TruckPageLoad = action.action.response;
                this.emit('TruckPageLoad');
                break;
            } 
            case "TruckTransferSubmit": {
                this.TruckTransferSubmit = action.action.response;
                this.emit('TruckTransferSubmit');
                break;
            }
            case "updateTransferAction": {
                this.updateTransferAction = action.action.response;
                this.emit('updateTransferAction');
                break;
            }
            case "DeleteUnavailableItems": {
                this.DeleteUnavailableItems = action.action.response;
                this.emit('DeleteUnavailableItems');
                break;
            }
            case "insertTransferAction": {
                this.insertTransferAction = action.action.response;
                this.emit('insertTransferAction');
                break;
            }
            case "TransferConfSubmit": {
                this.TransferResData = action.action.response;
                ;
                this.emit('TransferConfSubmit');
                break;
            }
            case "NOTIFY_InsertFavPage": {

                this.updateFavPageResponse.updateType = 1;
                this.updateFavPageResponse.responseStr = action.action.response;
                this.emit('updateFavPage');
                break;
            }
            case "NOTIFY_DeleteFavPage": {
                this.updateFavPageResponse.updateType = 2;
                this.updateFavPageResponse.responseStr = action.action.response;
                this.emit('updateFavPage');
                break;
            }
            case "NOTIFY_CurrentFavPage": {
                this.currentFavPageResponse = action.action.response;
                this.emit('favpage');
                break;
            }
        }
    }
}
const objBinToBinStore = new BinToBinStore;
// Dispatcher code
Dispatcher.register(objBinToBinStore.handleBinToBinStore.bind(objBinToBinStore));
export default objBinToBinStore;